import React, {useState, useEffect, Fragment} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { api, dashboardApproveUrl, eligibility, giaaPending } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { useParams } from "react-router-dom";
import Checkbox from "../schools/athlet/Checkbox";
import { FallingLines } from 'react-loader-spinner'
import moment from 'moment'


const GiaaDashboard = () => {


    useEffect( ()=> {
        $('body').removeClass('').addClass('sidebar-collapsed');
        AthleticPending();
    },[])

    let navigate = useNavigate()

    const { id } = useParams()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [resultAthletic, setResultAthletic] = useState([]);   
	const [athleticLength, setAthleticLength] = useState('');   
    const [loader, setLoader] = useState(true);  
    const [schools, setSchools] = useState([]);
    const [schoolid, setScholId] = useState([]);


    let token = "Bearer "+localStorage.getItem('token');



    const AthleticPending = () => {
         
        const instance = axios.create({

            baseURL: giaaPending,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
                if(response.data.data.length === 0){
                    navigate('/dashboard_new')
                }
                else{
                    setScholId(response.data.data[id].id)
                    setSchools(response.data.data[id])
                    setResultAthletic(response.data.data[id].athletic)   
                }
                setLoader(false)


          }).catch((error) =>{
            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }



    const approveAthletic = (aid) => {

                    
        let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            ids:isCheck,
            approval:approval
        }
        const instance = axios.create({
            baseURL: eligibility+schoolid+"/3/approve",
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{

            navigate('/giaa_dashboard/0')
            window.location.reload();
            
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
    }


    const rejectedAthletic = (aid) => {
        console.log("is length", isCheck.length)
        
        if(isCheck.length === 1){

        setAllFiles(false)
        setRejectReason(true)
        }
        else{
            alert('Select one item to Reject')
            setAllFiles(true)
            setRejectReason(false)

        }
    }


    const submitRejectReason = (aid) => {


        if(rejectvalue===""){

            window.location.reload();
            setAllFiles(true)
            setRejectReason(false)
            alert("Enter valid reason")
            
        }
        else{

        console.log('rejectedselected', selected) 

        let token = "Bearer "+localStorage.getItem('token');
        const datas = {
            ids:[rejectedselected],
            approval:rejected
        }
        const instance = axios.create({
            baseURL: eligibility+schoolid+"/"+aid+"/approve",
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{  
            // navigate("/athlet_list/"+id)
            // console.log("success")
        }).catch((error) =>{     
            console.log('error',error.message)
        }); 

        const datass = {
            ineligible_reason:rejectvalue
        }
        const instances = axios.create({
            baseURL: eligibility+schoolid+"/"+rejectedselected+"/ineligiblereason",
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instances.patch('',datass).then((response) =>{  
            setAllFiles(true)
            setRejectReason(false)

            window.location.reload();

            // navigate("/athlet_list/"+id)
            // console.log("success")
        }).catch((error) =>{     
            console.log('error',error.message)
        });
    }

    }




    const [approval, setApproval] = useState("APPROVED");
    const [rejected, setRejected] = useState("REJECTED");
    const [isCheck, setIsCheck] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [rejectedselected, setRejectSelected] = useState();
    const [selected, setSelected] = useState(); 
    const [allfiles, setAllFiles] = useState(true)
    const [rejectReason, setRejectReason] = useState(false)
    const [rejectvalue, setRejectValue] = useState('')

 

  
    const handleSelectAll = (e) => {
      setIsCheckAll(!isCheckAll);
      setIsCheck(resultAthletic.map((li) => li.id));
      console.log("check all", isCheck)
      if (isCheckAll) {
        setIsCheck([]);
      }
    };
  
    const handleClick = (e) => {
      const { id, checked } = e.target;
    //   console.log("eee", e.target)
      let selectId = parseInt(id)
      setIsCheck([...isCheck, selectId]);
      setRejectSelected(id)
      if (!checked) {
        setIsCheck(isCheck.filter((item) => item !== selectId));
      }
    //   console.log("isCheck", isCheck);
    };


    const dismissButton =()=>{
        // window.location.reload();
        setRejectReason(false)
   
}




    let sl=1;

    let arr=0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title">Pending by GIAA - {schools.schoolName}  </h2>
                        </div>
                    </div>




                {!rejectReason?

                    <div>

                    {!loader?
                        <div class="table-wrpr mt-5">
                        <table class="table sml-font">
                            <thead>
                                <tr>
                                    <th style={{paddingLeft:"35px", marginTop:"55px"}}>
                                        <div class="faculty-user checkbox-btn-options ">
                                            <span>&nbsp;</span> 
        
                                    <Checkbox
                                            type="checkbox"
                                            name="selectAll"
                                            id="selectAll"
                                            handleClicks={handleSelectAll}
                                            isChecked={isCheckAll}
                                        />   
        
        
        
                                        </div>
                                    </th>
                                    <th style={{paddingLeft:"5px"}}>GIAA Status</th>
                                    <th style={{paddingLeft:"5px"}}>Hos Status</th>
                                    <th style={{paddingLeft:"5px"}}>Name</th>
                                    <th style={{paddingLeft:"5px"}}>Grade</th>
                                    <th style={{paddingLeft:"5px"}}>DOB</th>
                                    <th style={{paddingLeft:"5px"}}>Age</th>
                                    <th style={{paddingLeft:"5px"}}>Entered 8th</th>
                                    <th style={{paddingLeft:"5px"}}>Entered 9th</th>
                                    <th style={{paddingLeft:"5px"}}>Date of Transfer</th>
                                    <th style={{paddingLeft:"5px"}}>Units</th>
                                    <th style={{paddingLeft:"5px"}}>Created at</th>
                                    <th style={{paddingLeft:"5px"}}>XFR</th>
                                    <th style={{paddingLeft:"5px"}}>Actions</th> 
                                </tr>
                            </thead>
                        <tbody>
           
                    
                    { resultAthletic?(
                        <Fragment>
                        {resultAthletic.map((item,index, ids, name)=> (
                                
                            <Fragment>
                                    <Fragment>
        
                                    {item.current_grade ==="13"?null:
                                <tr> 
        
        
                        <td class="checkbox-cntnr">
                            <div class="faculty-user checkbox-btn-options ">
                                <span>&nbsp;</span>
                                <Checkbox
                                            key={ids}
                                            type="checkbox"
                                            name={name}
                                            id={item.id}
                                            handleClicks={handleClick}
                                            isChecked={isCheck.includes(item.id)}
                                            className="select-individual-check"
                                        />
                                    </div>
                                    </td>
                                        
                    
        
                                    <Fragment>
                                            <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                                <Fragment>
                                                    {item.gisa_approval === "APPROVED"?
                                                    <div className="approveGisa">
                                                    <span style={{color:"green"}}>{item.gisa_approval}</span><br />
                                                    </div>:null
                                                    }
                                                    {item.gisa_approval === "REJECTED"?
                                                    <div className="rejectGisa">
                                                    <span style={{color:"red"}}>{item.gisa_approval}</span><br />
                                                    </div>:null
                                                    }
                                                    {item.gisa_approval === "PENDING"?
                                                    <div className="pendingGisa">
                                                    <span style={{color:"blue"}}>{item.gisa_approval}</span><br />
                                                    </div>:null
                                                    }
                                                </Fragment>
                                            </td>
                                            <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                                <Fragment>
        
                                                    {item.ho_approval === "APPROVED"?
                                                    <div className="approveGisa">
                                                    <span style={{color:"green"}}>{item.ho_approval}</span><br />
                                                    </div>:null
                                                    }
                                                    {item.ho_approval === "REJECTED"?
                                                    <div className="rejectGisa">
                                                    <span style={{color:"red"}}>{item.ho_approval}</span><br />
                                                    </div>:null
                                                    }
                                                    {item.ho_approval === "PENDING"?
                                                    <div className="pendingGisa">
                                                    <span style={{color:"blue"}}>{item.ho_approval}</span><br />
                                                    </div>:null
                                                    }
                                                </Fragment>
                                            </td>
                                        </Fragment>
        
                                            <td data-table-heading="Name" style={{paddingLeft:"5px"}}>{item.first_name}&nbsp;{item.last_name}</td>
                                            <td data-table-heading="Grade" style={{paddingLeft:"5px"}}>{item.current_grade}</td>
                                            <td data-table-heading="DOB" style={{paddingLeft:"5px"}}>{item.dob}</td>
                                            <td data-table-heading="Age" style={{paddingLeft:"5px"}}>{item.age}</td>
                                            <td data-table-heading="Entered 8th" style={{paddingLeft:"5px"}}>{item.year_8}</td>
                                            <td data-table-heading="Entered 9th" style={{paddingLeft:"5px"}}>{item.year_9}</td>
                                            <td data-table-heading="Date of Transfer" style={{paddingLeft:"5px"}}>{item.date_transfered}</td>
                                            <td data-table-heading="Units" style={{paddingLeft:"5px"}}>{item.units_passed}</td>
                                            <td data-table-heading="Created at" style={{paddingLeft:"5px"}}>{moment(item.createdAt).format('MM-DD-YYYY')}</td>
                                            {item.aes_status ==="NO"?<td data-table-heading="Created at" style={{paddingLeft:"5px"}}>NO</td>:
                                            <td data-table-heading="Created at" style={{paddingLeft:"5px",   color:"tomato", fontWeight:'800'}}>YES</td>}
                                            <td data-table-heading="Actions" >
        
                    
                                        <div class="list-action-wrpr text-right roundicons-text" >
                                        <Link  to={"/athletView/"+schoolid+'/'+item.id} title="View" ><i class="view icon-eye" style={{marginLeft:"-80px"}}></i><span style={{marginLeft:"-80px"}}>View</span></Link>
            
                                        </div>
                                    </td>
                    
                                </tr>
                                }
                                </Fragment>
        
                                </Fragment>))}
                                </Fragment>
                                )
                                
                                :null
                                    }
                            </tbody>
                        </table>   


                        <div class="col-md-5 btn-container">
                            <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{rejectedAthletic(selected)}}>Ineligible</button>
                            <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{approveAthletic(selected)}}>Approve</button>
                        </div>



                    </div>
                    
                    
                    :

                        <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                        <div className="fp-container">
                            <FallingLines
                                color="#fff"
                                width="50"
                                visible={true}
                                ariaLabel='falling-lines-loading'
                                />
                        </div>
                        </div>

                            }
</div>:


<div class="courses-container">
    <div class="course">
        <div class="course-preview">
            <h6>&nbsp;</h6>
            <h2>Ineligible Reason</h2>
            <a>&nbsp;<i class="fas fa-chevron-right"></i></a>
        </div>
        <div class="course-info">
        <h6>&nbsp;</h6>
            <textarea type="text" 
                class="form-textarea" 
                placeholder="Enter Reason" 
                rows="4"
                value={rejectvalue} 
                onChange={e => { setRejectValue(e.target.value) }}  /><br/><br/><br/><br/><br/>


            <button onClick={dismissButton} class="btn reason-dismiss" data-dismiss="alert" aria-label="Close" data-abc="true">Dismiss</button> 
            <button onClick={submitRejectReason} data-dismiss="alert" aria-label="Close" data-abc="true" class="btn reason-submit">Submit</button>
        </div>
    </div>

</div>  

}
                    



                    </div>

                </div>
            </aside>
        </div>
    )
};

export default GiaaDashboard;
